import { crudService } from '../_services/';
import alerts from '../_components/alerts';

export const logErroChaveNfeAction = {
    getLogErrosNfe
};

function getLogErrosNfe() {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'log/errosnfe';
        crudService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeLogsList(response.data));
                alerts.clean();
            })
    };
}

export function changeLogsList(logErroChaveNfe) {
    return {
        type: "FETECHED_ALL_LOG_ERRO_CHAVE_NFE",
        logErroChaveNfe: logErroChaveNfe
    }
}